import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";

function EditSite({ site, onClose, userId, getAllSites }) {
  const [loading, setLoading] = useState(false);

  //Initializing react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //Setting the existing data
  useEffect(() => {
    reset(site);
  }, [site]);

  //Function to update site details
  const onSubmit = (data) => {
    setLoading(true);
    const finalData = {
      ...data,
      userId: userId,
    };
    console.log("Final Data: ", finalData);
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/site/update-site/${site._id}`,
      headers: {},
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of onSubmit: ", response.data);
        setLoading(false);
        onClose();
        getAllSites();
        toast.success(response.data.message);
      })
      .catch((error) => {
        console.log("Error in updating site: ", error);
        toast.error("Error in updating site");
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm  backdrop-brightness-75"
      onClick={onClose}
    >
      <div
        className="relative max-h-[90%] w-[95%] max-w-2xl overflow-y-auto rounded-lg bg-white p-4 shadow-lg md:p-8 lg:h-auto lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <HiX
          className="absolute right-4 top-4 cursor-pointer text-primary hover:text-red-500"
          size={20}
          onClick={onClose}
        />
        <h1 className="text-center text-3xl font-bold tracking-wide text-primary">
          Add Site
        </h1>

        {/* Input Fields  */}
        <form
          action=""
          className="my-4 grid grid-cols-1 gap-4 md:grid-cols-2"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Site Name  */}
          <div className="flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="siteName"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Site Name <span className="text-red-500">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Site Name"
              {...register("siteName", { required: "Site Name is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.siteName ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.siteName && (
              <span className="text-sm text-red-500">
                {errors.siteName.message}
              </span>
            )}
          </div>

          {/* District  */}
          <div className="flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="district"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              District <span className="text-red-500">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter District"
              {...register("district", { required: "District is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.siteName ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.district && (
              <span className="text-sm text-red-500">
                {errors.district.message}
              </span>
            )}
          </div>

          {/* Start from  */}
          <div className="flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="rangesFrom"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Starts from
            </label>

            <input
              type="text"
              placeholder="Starts from "
              {...register("rangesFrom")}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.rangesFrom ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.rangesFrom && (
              <span className="text-sm text-red-500">
                {errors.rangesFrom.message}
              </span>
            )}
          </div>

          {/* Ends At  */}
          <div className="flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="rangesTo"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Ends At
            </label>

            <input
              type="text"
              placeholder="Ends at"
              {...register("rangesTo")}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.rangesTo ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.rangesTo && (
              <span className="text-sm text-red-500">
                {errors.rangesTo.message}
              </span>
            )}
          </div>

          {/* Site Description  */}
          <div className="flex flex-col gap-2 md:col-span-2">
            <label
              htmlFor="siteDescription"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Site Description
            </label>

            <textarea
              type="text"
              placeholder="Enter Site Description"
              {...register("siteDescription")}
              className={`resize-none rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.siteDescription ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.siteDescription && (
              <span className="text-sm text-red-500">
                {errors.siteDescription.message}
              </span>
            )}
          </div>

          {/* Buttons  */}
          <div className="flex gap-4 md:col-span-2">
            <button
              type="button"
              className="mt-4  w-1/2 rounded bg-gray-200 py-2 font-semibold tracking-wide text-gray-800 shadow-md hover:bg-gray-400 md:w-full"
              onClick={() => reset({ siteName: "", siteDescription: "" })}
            >
              Clear
            </button>

            <button
              type="submit"
              className=" mt-4  flex w-1/2 justify-center  rounded bg-primary py-2 font-semibold tracking-wide text-white shadow-md hover:bg-hoverPrimary   md:w-full"
            >
              {loading ? <div className="loaderButton"></div> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditSite;
